import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { ComponentsModule } from 'src/app/components/components.module';

import { UpdatePasswordPageRoutingModule } from './update-password-routing.module';
import { UpdatePasswordPage } from './update-password.page';

@NgModule({
  imports: [
    CommonModule,
    ComponentsModule,
    FormsModule,
    IonicModule,
    UpdatePasswordPageRoutingModule,
    ReactiveFormsModule
  ],
  declarations: [UpdatePasswordPage]
})
export class UpdatePasswordPageModule {}
